exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toolbox/node_modules/core-js/modules/_wks-ext.js
// module id = 259
// module chunks = 0